<template>
    <div class="data-item" v-if="data != null">
        <div class="lineContainer">
            <div class="line1"></div>
            <div class="line2"></div>
        </div>
        <div class="itemContainer">
            <div class="item">
                <div style="white-space: nowrap;">
                    <span class="value">{{ toThousands(data.value)  }}</span>
                    <span class="unit">{{ data.unit ? data.unit : "" }}</span>
                    <span class="icon" :style="color()">{{ data.icon }}</span>
                </div>
                <span class="key">{{ data.key ? data.key : "-" }}</span>
            </div>
        </div>
    </div>
</template>


<script>
    import countTo from "vue-count-to";
    export default {
        components: {
            countTo
        },
        name: "OperationData",
        props: {
            data: Object,
        },
        methods: {
            toThousands(num) {
                if (num == undefined ) {
                    return '--'
                }else if(num <0){
                    return 0
                }else if(isNaN(num)){
                    return '--'
                } else {
                    num = parseFloat(Number(num).toFixed(2))
                    if (num > 1)
                        return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')

                    return num
                }
            },
            color() {
                if (!this.data.value) {
                    return "color:#FD4238";
                } else if (this.data.value > 0.9) {
                    return "color:#68D86A";
                } else if (this.data.value > 0.5) {
                    return "color:#F5AA00";
                } else {
                    return "color:#FD4238";
                }
            },
        },
    };
</script>

<style scoped lang="less">
    .data-item {
        min-width: 23%;
        max-width: 28%;
        height: 100%;
        font-size: 14rem;
        color: #e6f3fd;
        display: flex;
        flex-direction: row;

        .lineContainer {
            margin-left: 100/192vw;
        }

        .line1 {
            .w(2);
            .h(36);
            background: #0d94ff;
            opacity: 0.3;
        }

        .line2 {
            .w(2);
            .h(6);
            background: #0d94ff;
            opacity: 0.7;
            margin-top: 30/108vh;
        }

        .itemContainer {
            margin-left: 100/192vw;
            margin-top: 50/108vh;
        }

        .item {
            height: 50%;
            justify-content: flex-start;
            align-items: flex-start;
            flex-wrap: nowrap;

            span:first-child {
                font-size: 16rem;
            }

            span:last-child {
                font-size: 14rem;
            }

            .icon {
                font-size: 16rem;
                margin-left: 50/192vw;
            }
        }
    }
</style>